module.exports = __webpack_public_path__ + "img/SOUTHASIA_CHEESE.533d1bc7.png";